import type { DocNode } from './content'

export const walkReplace = (
  nodes: DocNode[],
  id: string,
  patch: (node: DocNode) => DocNode
): DocNode[] =>
  nodes.map((node) => {
    if (node.id === id) return patch(node)
    if (node.children) {
      return { ...node, children: walkReplace(node.children, id, patch) }
    }
    return node
  })

export const flatten = (nodes: DocNode[]): Map<string, DocNode> => {
  const map = new Map<string, DocNode>()
  const visit = (list: DocNode[]) => {
    for (const node of list) {
      map.set(node.id, node)
      if (node.children) visit(node.children)
    }
  }
  visit(nodes)
  return map
}

export const firstDocId = (nodes: DocNode[]): string => {
  for (const node of nodes) {
    if (node.content !== undefined) return node.id
    if (node.children) {
      const childId = firstDocId(node.children)
      if (childId) return childId
    }
  }
  return ''
}

export const getAncestorIds = (
  nodes: DocNode[],
  targetId: string
): string[] | null => {
  for (const node of nodes) {
    if (node.id === targetId) return []
    if (node.children) {
      const found = getAncestorIds(node.children, targetId)
      if (found) return [node.id, ...found]
    }
  }
  return null
}
